import { render, staticRenderFns } from "./InformationDDC.vue?vue&type=template&id=6c7f4a74"
import script from "./InformationDDC.vue?vue&type=script&lang=ts"
export * from "./InformationDDC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports